import apiFetch from '../fetch';

export const toggleFollow = async (athleteId, isFollowing) => {
  const url = isFollowing ? `/api/follows/${athleteId}` : `/api/follows`;
  const method = isFollowing ? 'DELETE' : 'POST';

  const response = await apiFetch(url, {
    method: method,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: athleteId }),
  });

  return response;
};
